/* import __COLOCATED_TEMPLATE__ from './topics-filter.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type OptimizeSuggestionsService from 'embercom/services/optimize-suggestions-service';
import type IntlService from 'ember-intl/services/intl';

interface Signature {
  Args: {
    topics: string[];
    onTopicChange: (value: string) => void;
  };
}

export default class TopicsFilter extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare optimizeSuggestionsService: OptimizeSuggestionsService;

  get topicLabel(): string {
    if (this.args.topics.length === 0) {
      return this.intl.t('components.reporting.automation.optimize-suggestions.filter.topic.all');
    }
    if (this.args.topics.length === 1) {
      return this.args.topics[0];
    }
    // Multiple selections
    return this.intl.t('components.reporting.automation.optimize-suggestions.filter.selected', {
      count: this.args.topics.length,
    });
  }

  get isAllTopicsSelected(): boolean {
    return this.args.topics.length === 0;
  }

  get topicOptions(): Array<{ value: string; label: string }> {
    return this.optimizeSuggestionsService.getRelevantTopics().map((topic) => ({
      value: topic,
      label: topic,
    }));
  }

  @action
  handleTopicChange(value: string): void {
    this.args.onTopicChange(value);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::Filters::TopicsFilter': typeof TopicsFilter;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/filters/topics-filter': typeof TopicsFilter;
  }
}
